import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'tableData'
})
export class TableDataPipe implements PipeTransform {

	transform(value: any, args?: any): any {
		if (typeof(value) === 'object') {
			return JSON.stringify(value);
		}
		return value;
	}

}



// WEBPACK FOOTER //
// ./src/app/pipes/table-data.pipe.ts